export const useAppStore = defineStore("app", () => {
	const data = ref(null);

	const isLoading = ref(false);
	const placeholders = computed(
		() => data.value?.sitecore?.route?.placeholders
	);
	const route = computed(() => data.value?.sitecore?.route);
	const context = computed(() => data.value?.sitecore?.context);

	async function fetchRouteData(r = "/", lang = "en") {
		try {
			if (!r) r = "/";
			isLoading.value = true;

			console.log("Fetching route data for ", r, lang);

			const { data: sitecoreData, error } = await useFetch(() => `/proxy?route=${r}&lang=${lang}`, {
                deep: true
            });

			isLoading.value = false;

			if (toValue(error)) {
				throw toValue(error);
			}

			const scdata = toValue(sitecoreData);

			if (!scdata || !scdata?.sitecore?.route) {
				throw new Error("Page not found");
			}

			data.value = scdata;
		} catch (error) {
			isLoading.value = false;
			data.value = null;
			throw error;
		}
	}

	const isSideNavOpen = ref(false);
	function toggleSideNav() {
		isSideNavOpen.value = !isSideNavOpen.value;
	}
	function closeSideNav() {
		isSideNavOpen.value = false;
	}

	function setLoading(value) {
		isLoading.value = value;
	}

	const isPreShow = ref(false);

	function setPreShow(value) {
		isPreShow.value = value;
	}

	return {
		data,
		placeholders,
		context,
		route,
		fetchRouteData,
		isLoading,
		toggleSideNav,
		closeSideNav,
		isSideNavOpen,
		setLoading,
		isPreShow,
		setPreShow,
	};
});
